<template>
  <v-container>
    <v-sheet
      class="pa-2"
    >
      <v-layout row wrap> <!-- Start Layout -->
        <v-flex xs12>
          <v-layout row>
            <v-flex>
              <h1>{{ event.name }}</h1>
            </v-flex>
            <v-spacer />
            <v-flex  shrink>
              <v-btn
                round
                flat
                icon
                @click="$router.go(-1)"
              >
                <v-icon>
                  clear
                </v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 mb-1>
          <v-divider />
        </v-flex>
        <v-flex xs12 sm6>
          <v-layout column><!-- Start Col 1 -->
            <v-flex xs12>
              <p> {{ event.description }}</p>
            </v-flex>
            <v-flex xs12 hidden-sm-and-up>
              <div class="iframe-wrapper">
                <iframe
                  class="iframe"
                  width="100%"
                  height="400"
                  :src="mapSrc"
                  frameborder="0"
                  scrolling="no"
                  marginheight="0"
                  marginwidth="0"
                ></iframe>
              </div>
            </v-flex>
            <v-flex xs12 mb-2>
              <div style="float: left;">
                <v-icon>
                  place
                </v-icon>
              </div>
              <h2>Location</h2>
              <address class="pl-4">
              {{ rink.name }}<br>
              {{ rink.address }}<br>
              {{ rink.city }} {{ rink.state }}, {{ rink.zip }}<br>
              </address>
            </v-flex>
            <v-flex mx-5 my-1>
              <v-alert
                :value="waitlist"
                type="warning"
              >
                {{ $t('eventCard.waitlist') }}
              </v-alert>
            </v-flex>
            <v-flex xs10>
              <v-alert
                :value="soldout"
                type="error"
              >
                {{ $t('eventCard.soldout') }}
              </v-alert>
            </v-flex>
            <v-flex xs12 class="mb-2">
              <div style="float: left;">
                <v-icon>
                  schedule
                </v-icon>
              </div>
              <h2>Schedule</h2>
              <div class="pl-4">
                <em>Event Begins:</em> {{ eventDatetime }}<br>
              </div>
            </v-flex>
            <v-flex v-show="hasSessions" xs12 pl-4>
              <h4>Sessions</h4>
            </v-flex>
            <v-flex xs12 pl-4>
              <v-layout
                row
                wrap
                v-for="session in event.sessions"
                :key="session.id"
                class="mb-1"
              >
                <v-flex xs4 sm3 md3>
                  {{ viewDate(session.date, true) }}
                </v-flex>
                <v-flex xs8 sm3 md3>
                  {{ viewTime(session.start) }} - {{ viewTime(session.end) }}
                </v-flex>
                <v-spacer />
                <v-flex xs12>
                  {{ session.notes }}
                </v-flex>
                <v-flex xs12>
                <v-divider dark />
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout><!-- End Col 1 -->
        </v-flex>
        <v-flex>
          <v-layout column><!-- Start Col2 -->
            <v-flex xs12 hidden-xs-only>
              <div class="iframe-wrapper">
                <iframe
                  class="iframe"
                  width="100%"
                  height="400"
                  :src="mapSrc"
                  frameborder="0"
                  scrolling="no"
                  marginheight="0"
                  marginwidth="0"
                ></iframe>
              </div>
            </v-flex>
          </v-layout><!-- End Col2 -->
        </v-flex>
      </v-layout><!-- end layout -->
      <v-layout row pa-2>
        <v-flex xs6 sm3 md1>
          <v-btn
            flat
            @click="$router.push('/registration/'+event.id+'/0')"
            v-show="!soldout"
          >
            {{ $t('eventCard.registerBtn') }}
          </v-btn>
        </v-flex>
        <v-spacer />
      </v-layout>
    </v-sheet>
  </v-container>
</template>

<script>
import * as date from '../libs/js/dates'

export default {
  name: 'EventDetail',
  data() {
    return {
      locale: 'en-us',
      type: 'month',
      start: '2019-01-01',
      end: '2019-01-06',
    }
  },
  computed: {
    event() { return this.$store.state.events.find(e => e.id.toString() == this.eId) },
    eId() { return this.$route.params.id },
    rink() { return this.$store.state.rinks.find(r => r.id.toString() === this.event['location-id'].toString()) },
    mapSrc() {
      return 'https://www.google.com/maps/embed/v1/place?key='+process.env.VUE_APP_GMAP+'&q='+
        encodeURIComponent(this.rink.name.replace(' ', '+') + '+' +
        this.rink.address.replace(' ', '+') + '+' +
        this.rink.city.replace(' ', '+') + '+' +
        this.rink.state.replace(' ', '+') + '+' +
        this.rink.zip.replace(' ', '+') + '')
    },
    hasRink () {
      return (this.event['location-id'] == true) && (this.$store.state.rinks.find(r => r.id === this.event['location-id']) == true)
    },
    hasSessions () {
      return Array.isArray(this.event.sessions) && this.event.sessions.length > 0
    },
    bdateMin () {
      return date.viewDate(this.event['bdate-min'] || this.event['nhl-bdate-min'], this.$i18n.locale)
    },
    bdateMax () {
      return date.viewDate(this.event['bdate-max'] || this.event['nhl-bdate-max'], this.$i18n.locale)
    },
    ageRestriction () {
      return this.$t('eventCard.bdateRestriction').replace('%1', this.bdateMin).replace('%2', this.bdateMax)
    },
    eventDatetime () {
      return date.viewDatetime(this.event['event-datetime'], this.$i18n.locale, this.rink.time_zone)
    },
    viewDate () {
      return (val, short) => date.viewDate(val, this.$i18n.locale, short)
    },
    viewDatetime () {
      return (val) => date.viewDatetime(val, this.$i18n.locale, this.rink.time_zone)
    },
    viewTime () {
      return (val) => date.viewTime(val, this.$i18n.locale, this.rink.time_zone)
    },
    waitlist () {
      if (this.soldout) return false
      if (this.event.id) {
        return this.event.status == 'active-waitlist' || this.event['open-spaces'] < 1
      } else {
        return false
      }
    },
    soldout () {
      if (this.event.id) {
        if (this.event.status == 'soldout') {
          return true
        }
        if ((this.event.status.indexOf('promo') !== -1) &&
          (this.event['open-spaces'] < 1) &&
          (this.$store.state.team.use_waitlist == 0)) {
            return true
        }
        return false
      } else {
        return false
      }
    },
    promote () {
      if (this.event.id) {
        if (this.event.status.indexOf('presale') !== -1) {
          return this.viewDate(this.event['registration-open'], false)
        } else {
          return false
        }
      } else {
        return false
      }
    },
    startDate () {
      return this.event['event-datetime'].split(' ')[0]
    },
    endDate () {
      if (this.hasSessions) {
        return this.event.sessions[this.event.sessions.length - 1].date
      } else {
        return this.event['event-datetime'].split(' ')[0]
      }
    },
    sessionsByDate () {
      if (this.hasSessions) {
        let s = {}
        this.event.sessions.forEach( ses => {
          s[ses.date] = ses
        })
        return s
      } else {
        return {}
      }
    }
  },
  methods: {
  }
}
</script>

<style scoped>
address {
  font-style: normal;
}
.day {
  height: 50px;
}
.iframe-wrapper {
    position: relative;
    overflow: hidden;
    padding-top: 56.25%;
}
.iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
}
</style>